<template>
  <div class="blog-box2">
    <h2 class="card-title">
      Najnowszy artykuł na &nbsp;<a
        href="https://www.tvokazje.pl"
        target="_blank"
      >
        TVOkazje
      </a>
    </h2>
    <vs-row>
      <vs-col vs-lg="12" vs-sm="12">
        <a
          v-if="posts && posts[0]"
          v-bind:href="posts[0]['url']"
          target="_blank"
        >
          <img class="img2" v-bind:src="posts[0]['image']" />
          <div class="bottom-right2">
            <span class="blog-title2 card-subtitle">{{
              posts[0]["title"]
            }}</span>
          </div>
        </a>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
//import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "GalleryCarousel",
  props: {
    posts: {
      required: true
    }
  }
  // data: () => ({
  //   title: "GalleryCarousel",
  //   swiperOptionTop: {
  //     spaceBetween: 10,
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev"
  //     }
  //   },
  //   swiperOptionThumbs: {
  //     spaceBetween: 10,
  //     centeredSlides: true,
  //     slidesPerView: "auto",
  //     touchRatio: 0.2,
  //     slideToClickedSlide: true
  //   }
  // }),
  // mounted() {
  //   this.$nextTick(() => {
  //     const swiperTop = this.$refs.swiperTop.swiper;
  //     const swiperThumbs = this.$refs.swiperThumbs.swiper;
  //     swiperTop.controller.control = swiperThumbs;
  //     swiperThumbs.controller.control = swiperTop;
  //   });
  // },
  // components: {
  //   swiper,
  //   swiperSlide
  // }
};
</script>

<style lang="scss">
.blog-box2 {
  height: 413px;
  position: relative;
}
.img2 {
  max-height: 413px;
  max-width: 100%;
}
.bottom-right2 {
  position: absolute;
  font-size: 17px;
  opacity: 0.7;
  padding: 1%;
  background-color: aliceblue;
  bottom: 0;
  max-width: 520px;
  text-align: center;
}
.blog-title2 {
  color: black;
  font-weight: 800;
}
.dark-theme .blog-title2 {
  color: white;
}

.dark-theme .bottom-right2 {
  background-color: rgba(57, 65, 86, 0.5);
  opacity: 1;
}
</style>
